module.exports = __webpack_public_path__ + "fonts/BebasNeue Book.826140fa.otf";